<template>
<section class="mx-2">
  <b-row>
    <strong>Finished Goods</strong>
    <b-table :items="finished.items" :fields="finished.fields" class="my-2">
      <template slot="prodprice" slot-scope="data">
        {{ data.item.prodprice | formatDollars  }}
      </template>
      <template slot="fifosum" slot-scope="data">
          {{ fifoSum | formatDollars }}
          <div v-if="isFifoSumInaccurate()" class="ml small">($0 parts listed below)</div>
      </template>
      <template slot="avgsum" slot-scope="data">
          {{ avgSum | formatDollars }}
          <div v-if="isAvgSumInaccurate()" class="ml small">($0 parts listed below)</div>
      </template>
      <template slot="pricesum" slot-scope="data">
        {{ priceSum | formatDollars  }}
      </template>
    </b-table>
  </b-row>
  <b-row>
    <strong>Raw Material(s)</strong>
    <b-table :items="raw.items" :fields="raw.fields" class="my-2">
      <template slot="kititemtypename" slot-scope="data">
        {{ data.item.kititemtypename }}
        <br>
        <router-link target="_blank" :to="{ name: 'BOM KIT Info', query: {bomKitNumber: data.item.kititemnum} }">Dig In</router-link>
      </template>
      <template slot="avgcost" slot-scope="data">
        {{ data.item.avgcost | formatDollars }}
      </template>
      <template slot="fifocost" slot-scope="data">
        {{ data.item.fifocost | formatDollars }}
      </template>
      <template slot="prodprice" slot-scope="data">
        <div v-if="isNaN(data.item.prodprice)">
          {{ 999999 | formatDollars }}
        </div>
        <div v-else>
          {{ data.item.prodprice | formatDollars }}
        </div>
      </template>
      <template slot="quantity" slot-scope="data">
        {{ Number(data.item.quantity) }}
      </template>
      <template slot="qtyonhand" slot-scope="data">
        {{ Number(data.item.qtyonhand) }}
      </template>
      <template slot="qtynotavailabletopick" slot-scope="data">
        {{ Number(data.item.qtynotavailabletopick) }}
      </template>
      <template slot="locations" slot-scope="data">
        <div v-for="loc in (data.item.locations || '').split('\n')">{{loc}}</div>
      </template>
    </b-table>
  </b-row>
</section>
</template>

<script>
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    error: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      finished: {
        items: [],
        fields: [
          { key: 'kitnum', label: 'Kit Number', sortable: true },
          { key: 'kitdescription', label: 'Kit Description', sortable: true },
          { key: 'prodprice', label: 'Products Price', sortable: true },
          { key: 'fifosum', label: 'Raw Material FIFO Costs', sortable: true },
          { key: 'avgsum', label: 'Raw Material Est. Avg. Sum', sortable: true },
          { key: 'pricesum', label: 'Raw Material Product Price Sum', sortable: true },
          { key: 'minbuild', label: 'Qty Able to Build', sortable: true },
        ],
      },
      raw: {
        items: [],
        fields: [
          { key: 'kititemtypename', label: 'Item Type', sortable: true },
          { key: 'kititemnum', label: 'Item Num', sortable: true },
          { key: 'kititemdescription', label: 'Item Description', sortable: true },
          { key: 'minqty', label: 'Min Qty', sortable: true },
          { key: 'maxqty', label: 'Max Qty', sortable: true },
          { key: 'quantity', label: 'Quantity', sortable: true },
          { key: 'avgcost', label: 'Est. Avg. Cost', sortable: true },
          { key: 'fifocost', label: 'FIFO Cost', sortable: true },
          { key: 'prodprice', label: 'Products Price', sortable: true },
          { key: 'qtyonhand', label: 'Qty on Shelf', sortable: true },
          { key: 'locations', label: 'Locations', sortable: true },
          { key: 'qtyallocated', label: 'Total Qty Allocated', sortable: true },
          { key: 'qtyallocatedmo', label: 'Qty Allocated in MOs', sortable: true },
          { key: 'qtynotavailabletopick', label: 'Qty in Non-Pickable Locations', sortable: true },
          { key: 'openpodata', label: 'PO Info', sortable: true },
          { key: 'abletobuild', label: 'Kits Able to Build', sortable: true },
        ],
      },
    };
  },
  computed: {
    fifoSum() {
      return Math.round(this.raw.items.map( i => {
        return (i.fifocost || 0) * i.quantity;
      }).reduce( (i,a) => Number(i) + Number(a), 0) * 100 ) / 100;
    },
    avgSum() {
      return Math.round(this.raw.items.map( i => {
        return (i.avgcost || 0) * i.quantity;
      }).reduce( (i,a) => Number(i) + Number(a), 0) * 100 ) / 100;
    },
    priceSum() {
      return Math.round(this.raw.items.map( i => {
        return (i.prodprice || 0) * i.quantity;
      }).reduce( (i,a) => Number(i) + Number(a), 0) * 100 ) / 100;
    }
  },
  mounted() {
    axios.get(`${BASE_API}/fishbowl/kit/${this.item.productid}`).then((response) => {
      response.data.forEach((data) => {
        if (data.kittypeid == 10) {
          this.finished.items.push(data);
        } else {
          data.abletobuild = Number(data.quantity)
            > 0 ? Math.floor((Number(data.qtyonhand)
            - Number(data.qtyallocated)) / Number(data.quantity)) : 0;
          if(data.abletobuild == 0 && data.kititemtypename === 'Kit') data.abletobuild = '0-See This Kit';
          data._cellVariants = {
            avgcost: this.highlightZeroes(data.avgcost),
            fifocost: this.highlightZeroes(data.fifocost),
            prodprice: this.highlightNines(data.prodprice),
            abletobuild: this.highlightNumbers(data.abletobuild)
          };
          this.raw.items.push(data);
        }
      });
      let minbuild = Math.min.apply(null, this.raw.items.map(data => data.abletobuild));
      this.finished.items.forEach((item) => {
        item.minbuild = minbuild;
        item._cellVariants = {
          fifosum: this.isFifoSumInaccurate() ? 'tomato' : '',
          avgsum: this.isAvgSumInaccurate() ? 'tomato' : ''
        };
      })
    }).catch((error) => {
      console.error(error);
      this.alert.variant = 'danger';
      this.alert.message = 'Failed to fetch kit. See console for more information.';
    });
  },
  methods: {
    highlightNumbers(number) {
      if (number <= 0) return 'red';
      else if (number < 5) return 'orangered';
      else if (number < 10) return 'palevioletred';
      else if (number < 15) return 'pink';
      else if (number < 25) return 'orange';
      else if (number < 40) return 'yellow';
      else if (number < 50) return '';
      else if (number == '0-See This Kit') return 'lightblue';
      else return 'lightgreen';
    },
    highlightZeroes(number) {
      if (number == null || number == 0) return 'tomato';
    },
    highlightNines(number) {
      let regex = RegExp(/9{3,}/g);
      if (isNaN(number) || regex.exec(Math.round(number))) return 'lightblue';
    },
    isFifoSumInaccurate() {
      return this.raw.items.some(i => !i.fifocost || i.fifocost == 0)
    },
    isAvgSumInaccurate() {
      return this.raw.items.some(i => !i.avgcost || i.avgcost == 0)
    }
  },
}
</script>

<style>
.table-red { background-color: red; }
.table-tomato { background-color: tomato; }
.table-orangered { background-color: orangered; }
.table-palevioletred { background-color: palevioletred; }
.table-pink { background-color: pink; }
.table-orange { background-color: orange; }
.table-yellow { background-color: yellow; }
.table-lightblue { background-color: lightblue; }
.table-lightgreen { background-color: lightgreen; }
</style>



// WEBPACK FOOTER //
// src/components/inventory/KitInfo.vue